import Vue from "vue";
import VueRouter from "vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const Home = () => import(/* webpackChunkName: "home" */ "../views/Home.vue");
const Auth = () => import(/* webpackChunkName: "auth" */ "../views/Auth.vue");
const ForgotPassword = () =>
  import(/* webpackChunkName: "auth" */ "../views/Forgot-Password.vue");
const ForgotPasswordConfirm = () =>
  import(/* webpackChunkName: "auth" */ "../views/Forgot-Password-Confirm.vue");
const Services = () =>
  import(/* webpackChunkName: "services" */ "../views/Services.vue");
const ServiceSingle = () =>
  import(/* webpackChunkName: "services" */ "../views/Service-single.vue");
const My = () => import(/* webpackChunkName: "profile" */ "../views/My.vue");
const myProfile = () =>
  import(/* webpackChunkName: "profile" */ "../views/my/my-profile.vue");
const myTickets = () =>
  import(/* webpackChunkName: "tickets" */ "../views/Tickets.vue");
const myAppointments = () =>
  import(/* webpackChunkName: "appointments" */ "../views/Appointments.vue");
const myTicketsAll = () =>
  import(/* webpackChunkName: "tickets" */ "../views/tickets/all.vue");
const myTicketSingle = () =>
  import(/* webpackChunkName: "tickets" */ "../views/tickets/single-ticket.vue");
const Notifications = () =>
  import(/* webpackChunkName: "notifications" */ "../views/Notifications.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "Ласкаво просимо", layout: "sidebar", requiresAuth: false },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: Notifications,
    meta: { title: "Сповіщення", layout: "sidebar", requiresAuth: true },
  },
  {
    path: "/services",
    name: "services",
    component: Services,
    meta: { title: "Каталог сервісів", layout: "sidebar", requiresAuth: false },
  },
  {
    path: "/services/external/:id",
    name: "service-single-external",
    component: ServiceSingle,
    props: true,
    meta: { title: "Сервіс", layout: "sidebar", requiresAuth: false },
  },
  {
    path: "/services/local/:slug",
    name: "service-single-local",
    component: ServiceSingle,
    props: true,
    meta: { title: "Сервіс", layout: "sidebar", requiresAuth: false },
  },
  {
    path: "/my",
    redirect: "/my/profile/general",
    name: "my",
    component: My,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/my/profile/:tab",
        name: "my-profile",
        component: myProfile,
        meta: { title: "Мій профіль", layout: "sidebar", requiresAuth: true },
      },
    ],
  },
  {
    path:'/appointments',
    component:myAppointments,
    name:'appointments',
    meta: {  title: "Записи на прийом", layout: "sidebar",requiresAuth: true },
  },
  {
    path: "/tickets",
    name: "tickets",
    redirect: "/tickets/all",
    component: myTickets,
    meta: { title: "Мої звернення", layout: "sidebar", requiresAuth: true },
    children: [
      {
        path: "all",
        name: "tickets-all",
        component: myTicketsAll,
        meta: { title: "Мої звернення", layout: "sidebar", requiresAuth: true },
      },
      {
        path: "t/:id",
        name: "single-ticket",
        component: myTicketSingle,
        meta: { title: "Мої звернення", layout: "sidebar", requiresAuth: true },
      },
    ],
  },
  {
    path: "/auth/:case",
    name: "Auth",
    component: Auth,
    meta: { layout: "auth", requiresAuth: false },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: { layout: "auth", requiresAuth: false },
  },
  {
    path: "/forgot-password/confirm",
    name: "forgot-password-confirm",
    component: ForgotPasswordConfirm,
    meta: { layout: "auth", requiresAuth: false },
  },
  {
    path:'*',
    redirect:'/'
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const getCurrentUser = () =>
  new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
      unsubscribe();
      resolve(user);
    });
  });

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    const user = await getCurrentUser();
    if (!user) {
      next("/services");
      return;
    }
  }

  next();
});

export default router;
